import { render, staticRenderFns } from "./DepartmentList.vue?vue&type=template&id=e95e59cc"
import script from "./DepartmentList.vue?vue&type=script&lang=js"
export * from "./DepartmentList.vue?vue&type=script&lang=js"
import style0 from "./DepartmentList.vue?vue&type=style&index=0&id=e95e59cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports